import React, { Component } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
  CssBaseline, CircularProgress, Container, Grid, Box,
  Typography, Button, Divider, List, ListItem, ListItemButton,
  ListItemText, ListItemIcon, Chip, Collapse, IconButton, Tooltip,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import CustomizedSnackbars from '../../components/material-snackbars';
import HeaderMenu from '../../components/header-menu';
import Footer from '../../components/footer';
import { FormattedMessage, injectIntl } from 'react-intl';
import * as componentActions from '../../redux/actions/integrationauths';
import {
  Add as AddIcon,
  ViewKanban as KanbanIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  FiberManualRecord as DotIcon,
  Beenhere as BeenhereIcon,
} from '@mui/icons-material';
import { Link } from 'react-router-dom';

import TicketKanban from './TicketKanban';
import { getBoards, deleteBoard } from '../../services/kanban.service';
import { AbilityContext } from '../../config/ability-context';

const SIDEBAR_WIDTH = 240;

class Kanban extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading:             true,
      openNotification:    false,
      notificationVariant: 'error',
      notificationMessage: '',
      boards:              [],
      selectedBoardId:     null,
      sidebarOpen:         true,
      deleteModalOpen:     false,
      boardToDelete:       null,
    };

    this.isAdmGlobal = false;
    this.currentUserId = 0;

    const { userSession } = props;
    if (userSession?.user) {
      this.currentUserId = userSession.user.id;
      userSession.user.userrole?.forEach(item => {
        if (item.role.roletype === 0) this.isAdmGlobal = true;
      });
    }

    this.closeNotification   = this.closeNotification.bind(this);
    this.handleDeleteConfirm = this.handleDeleteConfirm.bind(this);
    this.handleDeleteCancel  = this.handleDeleteCancel.bind(this);
  }

  async componentDidMount() {
    try {
      const res    = await getBoards();
      const boards = res.data?.data ?? [];
      const defaultBoard = boards.find(b => b.isdefault) ?? boards[0];
      this.setState({
        boards,
        selectedBoardId: defaultBoard ? defaultBoard.id : null,
        loading:         false,
      });
    } catch (err) {
      const intl = this.props.intl;
      this.setState({
        loading:             false,
        openNotification:    true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({ id: 'process.error' }),
      });
    }
  }

  closeNotification() {
    this.setState({ openNotification: false });
  }

  async handleDeleteConfirm() {
    const { boardToDelete } = this.state;
    try {
      const res = await deleteBoard(boardToDelete.id);
      if (res?.data?.success) {
        this.setState(prev => ({
          boards: prev.boards.filter(b => b.id !== boardToDelete.id),
          selectedBoardId: prev.selectedBoardId === boardToDelete.id
            ? (prev.boards.find(b => b.id !== boardToDelete.id)?.id ?? null)
            : prev.selectedBoardId,
          deleteModalOpen:     false,
          boardToDelete:       null,
          openNotification:    true,
          notificationVariant: 'success',
          notificationMessage: 'Quadro excluído com sucesso.',
        }));
      }
    } catch {
      this.setState({
        deleteModalOpen:     false,
        boardToDelete:       null,
        openNotification:    true,
        notificationVariant: 'error',
        notificationMessage: 'Erro ao excluir o quadro.',
      });
    }
  }

  handleDeleteCancel() {
    this.setState({ deleteModalOpen: false, boardToDelete: null });
  }

  getLang() {
    return this.props.match?.params?.lang ?? 'pt';
  }

  canEditOrDelete(board) {
    return this.isAdmGlobal || board.createduser === this.currentUserId;
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props;
    const { loading, boards, selectedBoardId, sidebarOpen, openNotification, notificationVariant, notificationMessage, deleteModalOpen, boardToDelete } = this.state;
    const lang = this.getLang();

    if (loading) {
      return (
        <div className={classes.root}>
          <HeaderMenu />
          <main
            className={clsx(classes.content, {
              [classes.contentShift]: headerMenu.open,
            }, classes.actionsContent, {
              [classes.actionscontentShift]: actionsHeaderMenu.open,
            })}
          >
            <div className={classes.drawerHeader} />
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
              <CircularProgress />
            </Box>
          </main>
        </div>
      );
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}
          style={{ paddingLeft: 0 }}
        >
          <div className={classes.drawerHeader} />

          <Box sx={{ display: 'flex', height: 'calc(100vh - 64px)', overflow: 'hidden' }}>

            {/* ── Área principal do kanban (esquerda) ── */}
            <Box sx={{ flex: 1, overflow: 'hidden', position: 'relative' }}>
              {selectedBoardId ? (
                <TicketKanban
                  boardId={selectedBoardId}
                  key={selectedBoardId}
                  sidebarOpen={sidebarOpen}
                  onToggleSidebar={() => this.setState((s) => ({ sidebarOpen: !s.sidebarOpen }))}
                  {...this.props}
                />
              ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', gap: 2 }}>
                  <KanbanIcon sx={{ fontSize: 64, color: '#d1d5db' }} />
                  <Typography variant="h6" color="text.secondary">Nenhum quadro selecionado</Typography>
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    component={Link}
                    to={`/${lang}/kanban-board-edit`}
                    sx={{ textTransform: 'none', borderRadius: 2 }}
                  >
                    Criar primeiro quadro
                  </Button>
                </Box>
              )}
            </Box>

            {/* ── Sidebar de quadros (direita) ── */}
            <Box
              sx={{
                width:           sidebarOpen ? SIDEBAR_WIDTH : 0,
                minWidth:        sidebarOpen ? SIDEBAR_WIDTH : 0,
                transition:      'width 0.2s, min-width 0.2s',
                overflow:        'hidden',
                bgcolor:         '#f8f9fa',
                borderLeft:      '1px solid #e5e7eb',
                display:         'flex',
                flexDirection:   'column',
                flexShrink:      0,
              }}
            >
              {/* Cabeçalho da sidebar */}
              <Box sx={{ p: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                  <KanbanIcon fontSize="small" sx={{ color: 'text.secondary' }} />
                  <Typography variant="subtitle2" fontWeight="bold" color="text.secondary">
                    Quadros
                  </Typography>
                </Box>
                <Tooltip title="Novo quadro">
                  <IconButton
                    size="small"
                    component={Link}
                    to={`/${lang}/kanban-board-edit`}
                    sx={{ bgcolor: 'primary.main', color: '#fff', '&:hover': { bgcolor: 'primary.dark' }, width: 24, height: 24 }}
                  >
                    <AddIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>

              <Divider />

              {/* Lista de quadros */}
              <List dense sx={{ flex: 1, overflowY: 'auto', py: 0.5 }}>
                {boards.length === 0 ? (
                  <Box sx={{ px: 2, py: 3, textAlign: 'center' }}>
                    <Typography variant="caption" color="text.secondary">
                      Nenhum quadro criado.
                    </Typography>
                  </Box>
                ) : (
                  boards.map((board) => {
                    const selected = board.id === selectedBoardId;
                    const canActOnBoard = this.canEditOrDelete(board);
                    return (
                      <ListItem
                        key={board.id}
                        disablePadding
                      >
                        <ListItemButton
                          selected={selected}
                          disabled={!board.active}
                          onClick={() => this.setState({ selectedBoardId: board.id })}
                          sx={{
                            borderRadius: 1,
                            mx: 0.25,
                            px: 0.75,
                            position: 'relative',
                            overflow: 'hidden',
                            '&.Mui-selected': {
                              bgcolor: '#e8f0fe',
                              '&:hover': { bgcolor: '#dce8fd' },
                            },
                            '&.Mui-disabled': { opacity: 0.55, pointerEvents: 'none' },
                          }}
                        >
                          <ListItemIcon sx={{ minWidth: 18 }}>
                            {board.isdefault
                              ? (
                                <Tooltip title="Quadro padrão">
                                  <BeenhereIcon sx={{ fontSize: 18, color: 'primary.main' }} />
                                </Tooltip>
                              ) : (
                                <DotIcon sx={{ fontSize: 10, color: board.active ? '#10b981' : '#9ca3af' }} />
                              )
                            }
                          </ListItemIcon>
                          <Tooltip title={board.title} placement="left" enterDelay={500}>
                            <ListItemText
                              primary={board.title}
                              primaryTypographyProps={{
                                variant: 'body2',
                                fontWeight: selected ? 'bold' : 'normal',
                                noWrap: true,
                              }}
                            />
                          </Tooltip>
                          {canActOnBoard && (
                            <Box
                              sx={{
                                position: 'absolute',
                                right: 0,
                                top: 0,
                                bottom: 0,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.25,
                                pl: 2,
                                pr: 0.5,
                                background: selected
                                  ? 'linear-gradient(to right, transparent, #e8f0fe 45%)'
                                  : 'linear-gradient(to right, transparent, #f8f9fa 45%)',
                                opacity: selected ? 1 : 0,
                                '.MuiListItem-root:hover &': { opacity: 1 },
                                transition: 'opacity 0.15s',
                                zIndex: 1,
                              }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <Tooltip title="Editar quadro">
                                <IconButton
                                  size="small"
                                  component={Link}
                                  to={`/${lang}/kanban-board-edit/${board.id}`}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Excluir quadro">
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.setState({ deleteModalOpen: true, boardToDelete: board });
                                  }}
                                  sx={{ color: 'error.main' }}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          )}
                        </ListItemButton>
                      </ListItem>
                    );
                  })
                )}
              </List>

              <Divider />

              {/* Botão Adicionar na base */}
              <Box sx={{ p: 1.5 }}>
                <Button
                  fullWidth
                  variant="outlined"
                  size="small"
                  startIcon={<AddIcon />}
                  component={Link}
                  to={`/${lang}/kanban-board-edit`}
                  sx={{ textTransform: 'none', borderRadius: 2, borderStyle: 'dashed' }}
                >
                  Adicionar quadro
                </Button>
              </Box>
            </Box>

          </Box>

          {this.state.loading && (
            <Overlay>
              <CircularProgress color="secondary" />
            </Overlay>
          )}

          <Dialog open={deleteModalOpen} onClose={this.handleDeleteCancel}>
            <DialogTitle>Excluir quadro</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Tem certeza que deseja excluir o quadro <strong>{boardToDelete?.title}</strong>? Esta ação não pode ser desfeita.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleDeleteCancel}>Cancelar</Button>
              <Button onClick={this.handleDeleteConfirm} color="error" variant="contained">
                Excluir
              </Button>
            </DialogActions>
          </Dialog>

          <CustomizedSnackbars
            variant={notificationVariant}
            message={notificationMessage}
            isOpen={openNotification}
            toClose={this.closeNotification}
          />
        </main>
        <Footer />
      </div>
    );
  }
}

Kanban.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu:        state.headerMenu,
  userSession:       state.userSession,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(Kanban)));

Kanban.contextType = AbilityContext;
